<template>
    <div>
        <div class="popup_st04">
            <div :class="classPrefix + 'popup_wrap'">
                <div class="title"><span class="t02">{{ rainfallInfo.hjdNm }}</span></div>
                <div class="text rainfall">
                    <span class="pop_bt_state green">{{ rainfallInfo.airTypeNm }}</span>
                    <span> {{ formatDate(rainfallInfo.measureTime) }} 기준</span>
                </div>
                <div class="water-text3" v-if="rainfallInfo.type === 'water'">
                    <span class="pop_bt_state water-title"> 제방고 </span>
                    <span class="pop_bt_state water-text">{{ !isNaN(rainfallInfo.valObj.val7) ? rainfallInfo.valObj.val7 :  '-'}} {{ rainfallInfo.unit }}</span>
                </div>
                <div :class="rainfallInfo.type === 'rain' ? 'air_box rain' : 'air_box'">
                    <ul>

                        <li v-if="rainfallInfo.type === 'rain'">
                            <p class="txt01">현재</p>
                            <p :class="['txt02', typeof rainfallInfo.curLevel !== $_TYPE.UNDEF ? rainfallInfo.curLevel[4] : '']">
                                {{ typeof rainfallInfo.curLevel !== $_TYPE.UNDEF ? rainfallInfo.curLevel[2] : '' }}
                            </p>
                            <p class="txt03">{{ rainfallInfo.unit }}</p>
                        </li>
                        <li v-if="rainfallInfo.type === 'rain'">
                            <p class="txt01">3시간 누계</p>
                            <p :class="['txt02', typeof todaySumLevel !== $_TYPE.UNDEF ? todaySumLevel[4] : '']">
                                {{ typeof todaySumLevel !== $_TYPE.UNDEF ? todaySumLevel[2] : '' }}
                            </p>
                            <p class="txt03">{{ rainfallInfo.unit }}</p>
                        </li>
                        <li v-if="rainfallInfo.type === 'rain'">
                            <p class="txt01">금년 누계</p>
                            <p class="txt02 t_gray">
                            <!-- <p :class="['txt02', typeof todaySumLevel !== $_TYPE.UNDEF ? todaySumLevel[4] : '']"> -->
                                {{ typeof yearSumLevel !== $_TYPE.UNDEF ? yearSumLevel[2] : '' }}
                            </p>
                            <p class="txt03">{{ rainfallInfo.unit }}</p>
                        </li>

                        <li v-if="rainfallInfo.type === 'water'">
                            <p class="txt01">하천수위</p>
                            <p :class="['txt02', typeof rainfallInfo.level[4] !== $_TYPE.UNDEF ? rainfallInfo.level[4] : '']">
                                {{ typeof rainfallInfo.level !== $_TYPE.UNDEF ? rainfallInfo.level[2] : '' }}
                            </p>
                            <p class="txt03">{{ rainfallInfo.unit }}</p>
                        </li>
                        <li v-if="rainfallInfo.type === 'water'">
                            <p class="txt01">경보위</p>
                            <p class="txt02 t_gray">
                                {{ !isNaN(rainfallInfo.valObj.val8) ? rainfallInfo.valObj.val8 :  '-'}}
                            </p>
                            <p class="txt03">{{ rainfallInfo.unit }}</p>
                        </li>

                    </ul>
                </div>
            </div>
            <div class="pop_bt_close2"><a href="javascript: void(0);" class="self-close-btn">닫기</a></div>
        </div>
    </div>
</template>

<script>
import { $_TYPE } from '@/confs/common.const';
import {mapGetters} from "vuex";
import gripUtil from "@/libs/grip.util";
import airLevel from "@/libs/air.level.js";

export default {
    props: {
        classPrefix: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            rainfallInfo: {},
            measureTime: '',
            todaySumLevel: [],
            yearSumLevel: [],
        };
    },

    computed: {
    },

    updated() {
        if(typeof this.rainfallInfo.hjdNm !== $_TYPE.UNDEF) {
            this.$emit('loaded-rainfall-info', this.$el.innerHTML);
        }
    },

    methods: {
        setRainfallInfo(rainfallInfo) {
            this.measureTime = rainfallInfo.measureTime;
            this.todaySumLevel = airLevel.rainfallLevel(rainfallInfo.valObj.threeHourSum);
            this.yearSumLevel = airLevel.rainfallLevel(rainfallInfo.valObj.yearSum);
            this.rainfallInfo = Object.assign({}, rainfallInfo);
        },
        formatDate(val) {
            if(typeof val !== $_TYPE.UNDEF && val.length >= 12) {
                return gripUtil.formatDate(gripUtil.extractNumber(val), 'yyyy-MM-dd HH:mm');
            }
            return "";
        },
    },
}
</script>
<style>
.water-text3 {text-align: right;}
.water-text3 .water-title {color: #636363; border-right: none;}
.water-text3 .water-text {color: #777777; border-right: none;}
</style>
